import { ISalesChannel } from 'interfaces/ISalesChannel';
import { useCallback, useMemo } from 'react';
import { useFetch } from './useFetch';

export const useSalesChannelService = () => {
  const { callApi } = useFetch();

  const getAll = useCallback(async () => {
    const salesChannel = await callApi<ISalesChannel[]>({
      url: 'SalesChannel/GetAll',
      method: 'get',
      prefixMsgError: 'error in useUserService - getAll:'
    });

    return salesChannel;
  }, [callApi]);

  const get = useCallback(
    async (id: string) => {
      const sc = await callApi<ISalesChannel>({
        url: `SalesChannel/Get/${id}`,
        method: 'get',
        prefixMsgError: 'error in useSalesChannelService - get:'
      });

      return sc;
    },
    [callApi]
  );

  const add = useCallback(
    async (sc: ISalesChannel) => {
      await callApi({
        url: 'SalesChannel/Add',
        method: 'post',
        data: sc,
        prefixMsgError: 'error in useUserService - add:'
      });
    },
    [callApi]
  );

  const update = useCallback(
    async (sc: ISalesChannel) => {
      await callApi({
        url: `SalesChannel/Update/${sc.SalesChannelId}`,
        method: 'put',
        data: sc,
        prefixMsgError: 'error in useSalesChannelService - update:'
      });
    },
    [callApi]
  );

  return useMemo(
    () => ({
      salesChannelService: { get, getAll, add, update }
    }),
    [get, getAll, add, update]
  );
};
